export const defaultLeadForm = {
  // General Info
  validationType: "Electricity + Gas",
  leadDate: "2026-02-23",
  agentName: "Rizwan",
  businessName: "ABC Company Ltd",
  businessPhone: "+44 791 123345",
  contactName: "John Doe",
  billingName: "John Doe",
  businessAddress: "123 Business St, City, Postal Code ABC123",
  postalCode: "ABC123",

  // Electricity Details
  elecSupplier: "",
  elecAccount: "",
  elecContractEnd: "2027-02-23",
  elecPayment: "",
  elecDayRate: "",
  elecNightRate: "",
  elecEveRate: "",
  elecSupplyNumber: "",

  // Gas Details
  gasSupplier: "",
  gasAccount: "phone Number",
  gasContractEnd: "2027-02-23",
  gasPayment: "",
  gasDayRate: "",
  gasStandingCharge: "",
  gasAvgBill: "",
  gasMSN: "",
  gasBillingFreq: "MONTHLY",

  // Quality Review
  email: "john.doe@example.com",
  callbackDate: "",
};

export const supplierOptions = [
  "Select Supplier",
  "British Gas Lite",
  "British Gas",
  "YU Energy",
  "Valda Energy",
  "Smartest Energy",
  "TGP Energy",
  "ENGIE Power",
  "SEFE Energy",
  "Delta Gas and Power",
 "UGP Gas and Power",
 "YGP Gas and Power",
 "Dyce Energy",
 "Pazitive Energy",
 "Briyt Energy",
 "Corona Energy",
  "EDF Energy",
  "EON Next",
  "Npower",
  "Scottish Power",
  "SSE",
  "Octopus Energy",
];

export function normalizeSupplier(value) {
  if (!value) return "";
  const match = supplierOptions.find(
    (opt) => opt.toLowerCase() === value.toLowerCase()
  );
  return match || value; 
}



export const paymentMethodOptions = [
  "Select Payment Method",
  "Direct Debit",
  "Cheque",
  "Online Banking",
  "Credit Card",
];

export const meterTypeOptions = [
  "Select Meter",
  "Smart Meter",
  "Traditional Meter",
  "Prepayment Meter",
];

export const validationTypeOptions = [
  "Electricity + Gas",
  "Electricity Only",
  "Gas Only",
];

export const agentOptions = ["Rizwan", "Ahmed", "Sara", "Omar", "Fatima"];

export const billingFreqOptions = ["MONTHLY", "QUARTERLY", "ANNUALLY"];
